module.exports = __webpack_public_path__ + "flyer_background_milk_jug_019-5c1edc2b50606a130a653f0ce77e77dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_milk_jug_019.jpg
// module id = 1663
// module chunks = 1